// extracted by mini-css-extract-plugin
export default {"searchLayout":"search_searchLayout__y4IU0","icon":"search_icon__yl-8A","search":"search_search__jKKmQ","error":"search_error__uYKhi","button":"search_button__vsDcD"};